import React from "react";
import { withTranslation, I18nextProvider } from "react-i18next";
import { compose } from "recompose";
import { ar, en, fr, es, id, ko, it, ja, de, zh, tr, ru } from "../../config/i18n";
import invariant from "invariant";

const mapping = {
  ar: ar,
  en: en,
  fr: fr,
  es: es,
  'id-ID': id,
  ko: ko,
  it: it,
  ja: ja,
  zh: zh,
  "de-BE": de,
  ur: en,
  tr: tr,
  ru: ru
};

export const withLanguage = (language) =>
  compose(
    (BaseComponent) =>
      ({ t, i18n, ...props }) => {
        const map =
          mapping[typeof language === "function" ? language(props) : language];
        invariant(map, "language is out of reach, it should be in the mapping inside withLanguage component");

        return (
          <I18nextProvider i18n={map}>
            <BaseComponent {...props} />
          </I18nextProvider>
        );
      },
    withTranslation()
  );

export default withLanguage;
